import React, { useState, useEffect } from 'react';
import { Box, Flex, Text, Button, Slider, Switch, Badge, Spinner, Inset, Separator, RadioCards } from '@radix-ui/themes';
import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { COMPETENCY_COLORS } from '../../../utils/constants';
import QuestionsPicker from './QuestionsPicker';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import QuizEdit from './QuizEdit';
import { set } from 'lodash';
import TopicsPicker from './TopicsPicker';
import { QUIZ_TYPE } from '../../../utils/constants';
import aiService from '../../../services/aiService';
import { useConfirmDialog } from '../../../contexts/confirmDialog';

const QuizCreator = ({ course, onComplete, onCancel }) => {
    const [useRecommended, setUseRecommended] = useState(true);
    const [ratios, setRatios] = useState({ vocabulary: 33, concept: 33, application: 34 });
    const [difficulty, setDifficulty] = useState('medium'); // Default to Easy
    const [selectedQuestionIds, setSelectedQuestionIds] = useState([]);
    const [loading, setLoading] = useState({isLoading: false, text: ''}); // Track loading state
    const [step, setStep] = useState(1); // Step to track the flow of question generation
    const [quiz, setQuiz] = useState({
        course: course,
        teaching_plan_id: course.active_teaching_plan.id,
        topics: [],
        selected_question_ids: [],
        difficulty: 'medium',
        ratio: {vocabulary: 33, concept: 33, application: 34},
        status: 'draft',
        type:''
    });
    const [editing, setEditing] = useState('quiz_type');
    const { showConfirmDialog } = useConfirmDialog();

    useEffect(() => {
        console.log('QUIZ>>>>>>>>>>>>>>>>>>>>>>>>>', quiz);
    }, [quiz]);

    // const handleRatioChange = (type, value) => {
    //     const newValue = value[0]; // Slider returns an array, we take the first value
    //     setRatios((prevRatios) => ({
    //         ...prevRatios,
    //         [type]: newValue,
    //     }));
    // };

    useEffect(() => {
        if (useRecommended) {
            // Reset ratios to recommended values
            setDifficulty('medium'); // Reset difficulty to medium when using recommended ratios
            setRatios({ vocabulary: 33, concept: 33, application: 34 });
        }
    }, [useRecommended]);

    // const handleValueCommit = (type, value) => {
    //     const committedValue = value[0]; // Slider returns an array, we take the first value
    //     const remaining = 100 - committedValue;

    //     // Get the current sum of the remaining sliders
    //     const otherTypes = Object.keys(ratios).filter((key) => key !== type);
    //     const currentSum = otherTypes.reduce((sum, key) => sum + ratios[key], 0);

    //     // Calculate the proportional share for each remaining slider
    //     const updatedRatios = { ...ratios, [type]: committedValue };
    //     otherTypes.forEach((key) => {
    //         const ratio = currentSum === 0 ? 1 / otherTypes.length : ratios[key] / currentSum; // Handle edge case where currentSum is 0
    //         updatedRatios[key] = Math.round(ratio * remaining); // Distribute remaining proportionally
    //     });

    //     // Ensure the total adds up to exactly 100% (fix rounding errors)
    //     const total = Object.values(updatedRatios).reduce((sum, val) => sum + val, 0);
    //     if (total !== 100) {
    //         const adjustment = 100 - total;
    //         const lastKey = otherTypes[otherTypes.length - 1];
    //         updatedRatios[lastKey] += adjustment; // Adjust the last slider to fix rounding errors
    //     }

    //     setRatios(updatedRatios);
    // };

    // const handleGenerateQuestions = async () => {
    //     setLoading({isLoading: true, text: 'Generating questions...'});
    //     try {
    //         const params = {
    //             course_id: course.id,
    //             teaching_plan_id: course.active_teaching_plan.id,
    //             topics:quiz.topics.map(topic => topic.id),
    //             recommended_ratio:quiz.ratio,
    //             difficulty: quiz.difficulty
    //         };

    //         console.log('Generating questions with params:', params);

    //         // Simulate API call to generate questions
    //         const generateResponse = await aiService.generateQuestions(params);

    //         if(generateResponse.generated?.error) {
    //             console.log('Error generating questions:', generateResponse.generated.error);
    //             toast.error('Error generating questions: ' + generateResponse.generated.error.message);
    //             setLoading({isLoading: false, text: ''});
    //             return
    //         }

    //         if (!generateResponse || !generateResponse.generated) {
    //             throw new Error('Failed to generate questions');
    //         }

    //         const jsonMatch = generateResponse.generated.match(/```json\n([\s\S]*?)\n```/);
    //         const jsonString = jsonMatch ? jsonMatch[1] : null;
    //         if (!jsonString) {
    //             throw new Error('Invalid AI response format');
    //         }
    //         const response = JSON.parse(jsonString);
    //         const questions = response.map(question => ({
    //             ...question,
    //             id: uuidv4(),
    //             selected:false
    //         }));

    //         setQuestions(questions);
    //         console.log('Generated questions:', questions);
    //         setStep(2);
    //     } catch (error) {
    //         console.error('Error generating questions:', error);
    //     } finally {
    //         setLoading({isLoading: false, text: ''}); // Reset loading state
    //     }
    // };

    // const handleSelectionConfirmed = (selectedQuestionIds) => {
    //     setSelectedQuestionIds(selectedQuestionIds);
    //     // const updatedQuestions = questions.map((question) => {
    //     //     const isSelected = selectedQuestionIds.some((selectedId) => selectedId === question.id);
    //     //     return { ...question, selected: isSelected };
    //     // });

    //     // setQuestions(updatedQuestions);
    //     setStep(3); // Move to the next step
    // }

    const handleQuizTypeChange = (value) => {
        setQuiz(prev => ({...prev, type: value}))
        if(quiz.topics.length === 0) {
            setEditing('topics');
        }
    }

    const handleQuestionsSelectionCancel = () => {
        setQuiz({
            ...quiz,
            topics: [],
            lastLessonId: null
        });
        setEditing('topics');
    }

    const handleTopicSelectCancel = () => {
        setQuiz({
            ...content,
            topics: [],
            lastLessonId: null
        });
    }

    const handleCompleteTopicSelection = ({topics, lastLessonId}) => {
        const updateQuiz = {
            ...quiz,
            topics: topics,
            lastLessonId: lastLessonId
        };
        setQuiz(updateQuiz);
        setEditing('questions');
    }

    const handleQuestionsSelectionConfirmed = (questions, selectedQuestionIds) => {
        setSelectedQuestionIds(selectedQuestionIds);
        setQuiz({
            ...quiz,
            questions:questions,
            selected_question_ids: selectedQuestionIds});
        setEditing('quiz');
        setStep(3);
    }
    const handleOnCancel = () => {
        if(quiz.type.length > 0){
             showConfirmDialog(
                  (<Box>
                    <Text size="2" as="p" mb="2">Are you sure you want to cancel. This action cannot be undone</Text>
                    <Text size="1" as="p" mb="2">Any unsaved changes will be lost</Text>
                  </Box>),
                  () => {
                    onCancel?.();
                  },
                  {
                    title: `Cancel Quiz`,
                    type: 'danger',
                    icon: ExclamationTriangleIcon,
                    confirmText: 'Discard Quiz',
                    cancelText: 'Continue'
                  });
        } else {
            onCancel?.();
        }
        
    }

    

    if (loading.isLoading) {
        return (
            <Flex direction="column" align="center" justify="center" gap="4" style={{ height: '100%', minHeight:'290px', width:'100%', alignSelf:'center' }}>
                <Spinner size="2" />
                <Text size="1" as="p">{loading.text}</Text>
            </Flex>
        );
    }

    return (
        <>
            <Box style={{paddingBottom:'70px'}}>
                <Inset side="x">
                    <Box p="4" style={{borderBottom:'1px solid var(--gray-5)'}}>
                    <Text size="2" mb="2" as="p" weight="bold">Create Quiz - <Text style={{color:'var(--accent-9)'}}>{course.level.label} {course.subject.name}</Text></Text>
                    {editing == 'quiz_type' ? (
                        <>
                            <RadioCards.Root variant="classic" value={quiz.type} onValueChange={handleQuizTypeChange} columns={{ initial: "2", sm: "4" }} gap="2" mt="4">
                                <RadioCards.Item value="class_work">
                                    <Text size="1">ClassWork</Text>
                                </RadioCards.Item>
                                <RadioCards.Item value="trial">
                                    <Text size="1">Trial</Text>
                                </RadioCards.Item>
                                <RadioCards.Item value="assessment">
                                    <Text size="1">Assessment</Text>
                                </RadioCards.Item>
                                <RadioCards.Item value="exam">
                                    <Text size="1">Exam</Text>
                                </RadioCards.Item>
                            </RadioCards.Root>
                            </>
                    ) : (
                        <Text size="2" as="p" weight="bold">{QUIZ_TYPE[quiz.type]}</Text>  
                    )}
                    {quiz.type && (
                        <Box>
                            {quiz.type === 'class_work' && <Text size="1" style={{ fontStyle: 'italic', color: 'gray' }}>Class work to reinforce learning. This <Text weight="bold" color="jade">will be graded</Text> as part of the course.</Text>}
                            {quiz.type === 'trial' && <Text size="1" style={{ fontStyle: 'italic', color: 'gray' }}>A trial quiz for practice and self-assessment. This <Text weight="bold" color="orange">will not be graded</Text> as part of the course.</Text>}
                            {quiz.type === 'assessment' && <Text size="1" style={{ fontStyle: 'italic', color: 'gray' }}>An assessment to evaluate understanding and skills.</Text>}
                            {quiz.type === 'exam' && <Text size="1" style={{ fontStyle: 'italic', color: 'gray' }}>A formal exam for comprehensive evaluation.</Text>}
                        </Box>
                    )}
                    </Box>
            
                </Inset>
                {quiz.type && (
                    editing == 'topics' ? 
                    (<Inset side="x" py="4">
                        <Box p="4" style={{borderBottom:'1px solid var(--gray-5)'}}>
                        <TopicsPicker onComplete={handleCompleteTopicSelection} teachingPlan={course.active_teaching_plan} onCancel={handleTopicSelectCancel} selected={quiz.topics}/>
                        </Box>
                    </Inset>) : (
                        <Inset side="x" clip="padding-box">
                            <Box p="2" style={{borderBottom:'1px solid var(--gray-5)'}}>
                                <Flex direction="row" justify="between" align="center" gap="4">
                                    <Text size="1">Selected Topics</Text>
                                    <Badge>{quiz.topics.length}</Badge>
                                </Flex>
                            </Box>
                        </Inset>
                    )
                )}
                {quiz.topics?.length > 0 && (
                    editing == 'questions' ? 
                    (<Inset side="x">
                        <Box p="4" style={{borderBottom:'1px solid var(--gray-5)'}}>
                            <QuestionsPicker 
                                course={course}
                                quizType = {quiz.type}
                                prevQuestions={quiz.questions}
                                topics={quiz.topics} 
                                prevSelection={selectedQuestionIds}
                                onComplete={handleQuestionsSelectionConfirmed} 
                                onCancel={handleQuestionsSelectionCancel} 
                            />
                        </Box>
                    </Inset>
                    ) : (
                        <Inset side="x" clip="padding-box">
                            <Box p="2" style={{borderBottom:'1px solid var(--gray-5)'}}>
                                <Flex direction="row" justify="between" align="center" gap="4">
                                    <Text size="1">Selected Questions</Text>
                                    <Badge>{quiz.questions?.length}</Badge>
                                </Flex>
                            </Box>
                        </Inset>
                    )
                )}
                {quiz.questions?.length > 0 && (
                    editing == 'quiz' ? (
                    <Inset side="x" clip="padding-box">
                        <Box p="2" style={{borderBottom:'1px solid var(--gray-5)'}}>
                            <QuizEdit quiz={quiz} onSaveQuiz={onComplete} onCancel={onCancel} />
                        </Box>
                    </Inset>
                    ) : (
                        <Inset side="x" clip="padding-box">
                            <Box p="2" style={{borderBottom:'1px solid var(--gray-5)'}}>
                                <Text>Quiz complete</Text>
                            </Box>
                        </Inset>
                    )
                )}
                {/* <Flex direction="column" gap="4" maxWidth="600px">
                    <Flex align="center" gap="2">
                        <Text size="2">Use Recommended</Text>
                        <Switch
                            checked={useRecommended}
                            onCheckedChange={(checked) => setUseRecommended(checked)}
                        />
                    </Flex>
                    {!useRecommended && (
                        <Flex direction="column" gap="4">
                            <Text size="1" weight="bold">Difficulty</Text>
                        <RadioCards.Root defaultValue="medium" onValueChange={(value) => setDifficulty(value)} columns={{ initial: "1", sm: "3" }}>
                            <RadioCards.Item value="easy">
                                <Flex direction="column" width="100%">
                                    <Text weight="bold">Easy</Text>
                                </Flex>
                            </RadioCards.Item>
                            <RadioCards.Item value="medium">
                                <Flex direction="column" width="100%">
                                    <Text weight="bold">Medium</Text>
                                </Flex>
                            </RadioCards.Item>
                            <RadioCards.Item value="hard">
                                <Flex direction="column" width="100%">
                                    <Text weight="bold">Hard</Text>
                                </Flex>
                            </RadioCards.Item>
                        </RadioCards.Root>
                            
                        <Flex align="center" gap="2">
                            <Text size="1" weight="bold" as="p" style={{width:'200px'}}>Vocabulary({ratios.vocabulary}%)</Text>
                                <Slider
                                    color={COMPETENCY_COLORS.vocabulary}
                                    style={{width: '100%'}}
                                    value={[ratios.vocabulary]}
                                    onValueChange={(value) => handleRatioChange('vocabulary', value)}
                                    onValueCommit={(value) => handleValueCommit('vocabulary', value)}
                                />
                        </Flex> 
                        <Flex align="center" gap="2">
                            <Text size="1" weight="bold" as="p" style={{width:'200px'}}>Concept({ratios.concept}%)</Text>
                            <Slider
                                color={COMPETENCY_COLORS.concept}
                                value={[ratios.concept]}
                                onValueChange={(value) => handleRatioChange('concept', value)}
                                onValueCommit={(value) => handleValueCommit('concept', value)}
                                min={0}
                                max={100}
                            />
                        </Flex>
                        <Flex align="center" gap="2">
                            <Text size="1" weight="bold" as="p" style={{width:'200px'}}>Application({ratios.application}%)</Text>
                            <Slider
                                color={COMPETENCY_COLORS.application}
                                value={[ratios.application]}
                                onValueChange={(value) => handleRatioChange('application', value)}
                                onValueCommit={(value) => handleValueCommit('application', value)}
                                min={0}
                                max={100}
                            />
                        </Flex>
                    </Flex>
                    )}
                <Flex gap="4">
                    <Button onClick={handleGenerateQuestions} disabled={loading.isLoading}>
                        {loading.isLoading ? 'Generating...' : 'Generate'}
                    </Button>
                    <Button variant="soft" onClick={onCancel}>
                        Cancel
                    </Button>
                </Flex>
            </Flex> */}
        </Box>
        {/* {step == 2 && (
            <Box>
                <QuestionsPicker 
                    questions={quiz.questions}
                    topics={quiz.topics}
                    onComplete={handleSelectionConfirmed} 
                    onCancel={onCancel} 
                />
            </Box>
        )} */}
        {/* {step == 3 && (
            <Box>
                <Text size="2" weight="bold" as="p">Review and Finalize</Text>
                
            </Box>
        )}*/}
        <Flex justify="end" align="center" p="4" gap="2" style={{width:'100%', position:'absolute', bottom:'0', left:'0', right:'0', background:'var(--gray-4)'}}>
            <Button onClick={handleOnCancel} variant="soft">Cancel</Button>
            {/* <Button disabled={loading.isLoading || quiz.selected_question_ids.length < 1} >Save</Button> */}
        </Flex> 
        </>
    );
};

export default QuizCreator;